import "./FormGroup.css";
import cn from "classnames";
import type { ComponentPropsWithRef, FC } from "react";

interface FormGroupProps extends ComponentPropsWithRef<"input"> {
  error?: string;
  label: string;
  required?: boolean;
  htmlFor: string;
}

export const FormGroup: FC<FormGroupProps> = (props) => {
  const { error, label, htmlFor, className, required = false, ...rest } = props;
  return (
    <div className={cn("form-group", { error }, className)} {...rest}>
      <label className={cn({ required })} htmlFor={htmlFor}>
        {label}
      </label>
      <div>{props.children}</div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};
